export function createNowDateStr () {
  const date = new Date()
  const dateStr = date.getDate().toString()
  const month = date.getMonth()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const milliseconds = date.getMilliseconds()
  return (
    date.getFullYear().toString() + '-' + (
      (month + 1).toString().length === 2
        ? (month + 1).toString()
        : '0' + (month + 1).toString()
    ) + '-' + (
      dateStr.length === 2
        ? dateStr
        : '0' + dateStr
    ) + ' ' + (
      hours.toString().length === 2 ? hours.toString() : '0' + hours.toString()
    ) + ':' + (
      (parseInt(minutes / 5) * 5).toString().length === 2
        ? (parseInt(minutes / 5) * 5).toString()
        : '0' + (parseInt(minutes / 5) * 5).toString()
    ) + ':' + (
      seconds.toString().length === 2
        ? seconds
        : `0${seconds}`
    ) + `:${milliseconds}`
  )
}

const LEVEL_TO_LOG_LEVEL = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
  verbose: 4
}
let config = {
  level: 'debug'
}

export function initLogger (options = {}) {
  config = {
    ...config,
    ...options
  }
}

export function shouldLogUtil (level) {
  return LEVEL_TO_LOG_LEVEL[level] <= LEVEL_TO_LOG_LEVEL[config.level]
}

export function logUtil (label) {
  return {
    error: function () {
      shouldLogUtil('error') && console.error(`${createNowDateStr()} [${label}]:`, ...arguments)
    },
    warn: function () {
      shouldLogUtil('warn') && console.warn(`${createNowDateStr()} [${label}]:`, ...arguments)
    },
    debug: function () {
      shouldLogUtil('debug') && console.debug(`${createNowDateStr()} [${label}]:`, ...arguments)
    },
    log: function () {
      shouldLogUtil('log') && console.log(`${createNowDateStr()} [${label}]:`, ...arguments)
    },
    info: function () {
      shouldLogUtil('info') && console.info(`${createNowDateStr()} [${label}]:`, ...arguments)
    }
  }
}
